// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2LkZf","footer":"ModalFilter_footer__2EHvc"};